import { AlertCircle, Check, CircleHelp } from "lucide-react";
import type { Mastery } from "../hooks/useProgress";

const masteryMeta: Record<
  Mastery,
  { label: string; className: string; icon: typeof Check }
> = {
  known: { label: "已认识", className: "known", icon: Check },
  fuzzy: { label: "待巩固", className: "fuzzy", icon: AlertCircle },
  new: { label: "学习中", className: "new", icon: CircleHelp }
};

export const MasteryPill = ({ mastery }: { mastery?: Mastery }) => {
  if (!mastery) return <span className="mastery-pill unseen">未学习</span>;
  const meta = masteryMeta[mastery];
  const Icon = meta.icon;
  return (
    <span className={`mastery-pill ${meta.className}`}>
      <Icon size={13} />
      {meta.label}
    </span>
  );
};
